import React from 'react';
import { Grid, CardContent, Typography } from '@mui/material';

const metrics = [
  { label: 'Business Volume', value: '₹1.24 Cr', color: 'primary' },
  { label: 'Orders', value: '286', color: 'secondary' },
  { label: 'Growth', value: '+34%', color: 'success' },
  { label: 'Trust Score', value: '96/100', color: 'error' },
];

const BusinessPerformance = () => (
  <Grid container spacing={2} sx={{ mb: 2 }}>
    {metrics.map((m) => (
      <Grid item xs={12} sm={6} md={3} key={m.label} sx={{ textAlign: 'center', background: 'var(--color-bg)', borderRadius: 'var(--radius-lg)' }}>
        <CardContent>
          <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
            {m.label}
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 700, color: m.color === 'primary' ? 'var(--brand-primary)' : m.color === 'secondary' ? 'var(--color-primary)' : m.color === 'success' ? 'var(--color-success)' : 'var(--color-error)' }}>
            {m.value}
          </Typography>
        </CardContent>
      </Grid>
    ))}
  </Grid>
);

export default BusinessPerformance;